

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';

// --- PUBLIC COMPONENTS ---
import Navbar from './head_foot/Navbar.jsx';
import Footer from './head_foot/Footer.jsx';
import ServicesMarquee from './head_foot/ServicesMarquee.jsx';
import Home from './home';
import GlobalEprcPage from './GlobalEprcPage.jsx';
import ContactPage from './ContactPage.jsx';
import AboutPage from './AboutPage.jsx';
import ManpowerRecruitmentPage from './sub/ManpowerRecruitmentPage.jsx';
import SkillUpgradationPage from './sub/SkillUpgradationPage.jsx';
import HROutsourcingPage from './sub/HROutsourcingPage.jsx';
import TravelTourismPage from './sub/TravelTourismPage.jsx';  
import ITCareersPage from './Carrers_sub/ITCareersPage.jsx';
import NonITCareersPage from './Carrers_sub/NonITCareersPage.jsx';
import JobDetailPage from './Carrers_sub/JobDetailPage.jsx';
import PricingPage from './PricingPage.jsx';

// --- ADMIN COMPONENTS ---
import AdminLayout from './Admin/AdminLayout.jsx';
import AdminLogin from './Admin/AdminLogin.jsx';
import AdminJobs from './Admin/AdminJobs.jsx';
import AdminDashboard from './Admin/AdminDashboard.jsx';
import ApplicationsPage from './Admin/ApplicationsPage.jsx';
import DemoBookingsPage from './Admin/DemoBookingsPage.jsx';
import EnquiriesPage from './Admin/EnquiriesPage.jsx';
import ITSolutionsPage from './sub/ITSolutionsPage.jsx';
import ServiceDetailPage from './ServiceDetailPage.jsx';
import DigitalMarketingPage from './DigitalMarketingPage.jsx';

// --- SECURITY: PROTECTED ROUTE GATEKEEPER ---
const ProtectedRoute = ({ children }) => {
  // Check if admin is logged in (sessionStorage is safer than localStorage for sensitive sessions)
  const isAuthenticated = sessionStorage.getItem('adminToken') === 'true';
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

// --- LAYOUTS ---

// 1. Public Layout: Main site look and feel
const PublicLayout = ({ navLinks, handleNavigation }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <ServicesMarquee />
      <Navbar navLinks={navLinks} scrollToSection={handleNavigation} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer navLinks={navLinks} scrollToSection={handleNavigation} />
    </div>
  );
};

// 2. Admin Dashboard Layout: Dashboard look and feel (Sidebar)
// const AdminLayout = () => {
//   const adminMenu = [
//     { name: 'Dashboard', path: '/admin/dashboard', icon: '📊' },
//     { name: 'Manage Jobs', path: '/admin/jobs', icon: '💼' },
//     { name: 'Applications', path: '/admin/applications', icon: '📩' },
//     { name: 'Settings', path: '/admin/settings', icon: '⚙️' },
//     { name: 'View Site', path: '/', icon: '🌐' },
//   ];

//   const handleLogout = () => {
//     sessionStorage.removeItem('adminToken');
//     window.location.href = '/admin-login';
//   };

//   return (
//     <div className="flex min-h-screen bg-slate-100">
//       <aside className="w-64 bg-slate-900 text-white flex flex-col fixed h-full">
//         <div className="p-6 text-xl font-bold border-b border-slate-800 text-blue-400">GEPRC Admin</div>
//         <nav className="flex-grow p-4 space-y-2">
//           {adminMenu.map(item => (
//             <Link key={item.path} to={item.path} className="flex items-center space-x-3 p-3 rounded hover:bg-slate-800 transition">
//               <span>{item.icon}</span>
//               <span>{item.name}</span>
//             </Link>
//           ))}
//         </nav>
//         <button 
//           className="p-4 text-left text-red-400 hover:bg-slate-800 transition border-t border-slate-800" 
//           onClick={handleLogout}
//         >
//           Logout
//         </button>
//       </aside>
//       <main className="ml-64 flex-grow p-8">
//         <Outlet />
//       </main>
//     </div>
//   );
// };

// --- MAIN APP COMPONENT ---
const App = () => {
  const navLinks = [
    { name: 'Home', id: '/', isPage: true },
    { name: 'Pricing', id: '/pricing', isPage: true },
    { name: 'About Us', id: '/about', isPage: true },
    { 
      name: 'Services', 
      id: 'services', 
      subLinks: [
        { name: 'Manpower & Recruitment', id: '/manpower-recruitment', isPage: true },
        { name: 'Outsourcing', id: '/hr-outsourcing', isPage: true }, 
        { name: 'IT Solutions', id: '/it-solutions', isPage: true },
        { name: 'Skill Upgradation', id: '/skill-upgradation', isPage: true }, 
        { name: 'Travel and Tourism', id: '/travel-tourism', isPage: true }
      ]
    },
    { 
      name: 'Career', 
      id: 'career',
      subLinks: [
        { name: 'IT Roles', id: '/it-careers', isPage: true },
        { name: 'Non-IT Roles', id: '/non-it-careers', isPage: true }
      ]
    },
    { name: 'Contact', id: '/contact', isPage: true },
  ];

  const handleNavigation = (id, isPage) => {
    if (isPage) {
      window.location.href = id;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
      }
    }
  };

  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<PublicLayout navLinks={navLinks} handleNavigation={handleNavigation} />}>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="/global-eprc" element={<GlobalEprcPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/manpower-recruitment" element={<ManpowerRecruitmentPage />} />
          <Route path="/skill-upgradation" element={<SkillUpgradationPage />} />
          <Route path="/hr-outsourcing" element={<HROutsourcingPage />} />
          <Route path="/travel-tourism" element={<TravelTourismPage />} />
          <Route path="/it-careers" element={<ITCareersPage />} />
          <Route path="/non-it-careers" element={<NonITCareersPage />} />
          <Route path="/careers/:jobId" element={<JobDetailPage />} />
          <Route path="/it-solutions" element={<ITSolutionsPage />} />
          <Route path="/services/digital-marketing" element={<Navigate to="/digital-marketing" replace />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
        </Route>

        {/* ADMIN LOGIN (Stand-alone page) */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* PROTECTED ADMIN DASHBOARD ROUTES */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* Default redirect from /admin to dashboard */}
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          
        <Route path="dashboard" element={
          <div className="bg-white p-2 md:p-10 rounded-3xl shadow-sm border border-slate-100 min-h-[600px]"> 
            <AdminDashboard />
          </div>
        } />
          
          <Route path="jobs" element={<AdminJobs />} />
          <Route 
            path="applications" 
            element={
              <div className="bg-slate-50 p-2 md:p-8 rounded-3xl min-h-screen">
                <ApplicationsPage />
              </div>
            } 
          />
          <Route 
            path="demos" 
            element={
              <div className="bg-slate-50 p-2 md:p-8 rounded-3xl min-h-screen">
                <DemoBookingsPage />
              </div>
            } 
          />
          <Route 
            path="enquiries" 
            element={
              <div className="bg-slate-50 p-2 md:p-8 rounded-3xl min-h-screen">
                <EnquiriesPage />
              </div>
            } 
          />          
          <Route path="settings" element={<div className="bg-white p-6 rounded shadow"><h2 className="text-2xl font-bold">Admin Settings</h2></div>} />
        </Route>

        {/* 404 Redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
